import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DayOfWeek } from 'src/app/model/day-of-week.model';
import { RestSalasDataSource } from 'src/app/model/rest.salas.datasource';
import { SelecionarPacienteComponent } from '../selecionar-paciente/selecionar-paciente.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-add-horario',
    templateUrl: './add-horario.component.html',
    styleUrls: ['./add-horario.component.scss'],
})
export class AddHorarioComponent implements OnInit {

    @Input() itensHorarios: any;
    @Input() totalVagasSala: number;
    @Input() horario: number;
    @Input() diaDaSemana: DayOfWeek;
    @Input() salaId: string;
    @Output() updateReservas = new EventEmitter();

    constructor(private modalService: NgbModal, private reservaRepository: RestSalasDataSource, private toastr: ToastrService) { }

    ngOnInit() {
    }

    horariosVagos() {
        return this.totalVagasSala - (this.itensHorarios?.length ?? 0);
    }

    abrirModalReserva() {
        const modalRef = this.modalService.open(SelecionarPacienteComponent);
        modalRef.componentInstance.reservaForm.horario = this.horario;
        modalRef.componentInstance.reservaForm.diaDaSemana = this.diaDaSemana;
        modalRef.componentInstance.reservaForm.salaId = this.salaId;

        modalRef.closed.subscribe(c => this.updateReservas.emit());
    }

    removerReserva(reservaId: string) {
        if (confirm("Tem certeza que deseja remover a reserva?")) {
            this.reservaRepository.removerReserva(reservaId).subscribe(
                () => {
                    this.toastr.success('Reserva removida')
                    this.updateReservas.emit();
                },
                () => {
                    this.toastr.error('Erro ao tentar remover reserva');
                }
            );
        }
    }

    isColorLight(hexColor: string) {
        // Remove o "#" caso esteja presente
        hexColor = hexColor.replace('#', '');

        // Converte hexadecimal para RGB
        const r = parseInt(hexColor.substring(0, 2), 16);
        const g = parseInt(hexColor.substring(2, 4), 16);
        const b = parseInt(hexColor.substring(4, 6), 16);

        // Calcula o brilho
        const brightness = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );

        // Retorna true se a cor for clara
        return brightness > 127.5;
    }

    tratarNome(nomeCompleto: string) {
        const words = nomeCompleto.split(' ');
        return `${words[0]} ${words[1].charAt(0)}.`;
    }
}